import { Box, SxProps, Theme, Typography } from '@mui/material';

import { useLanguage } from '../../hooks';
import { FormAnswersForbiddenAccessStateIcon } from '../icons/formAnswerForbiddenAccessStateIcon';

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    height: '100%',
    width: '100%',
    backgroundColor: '#FAFBFF',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
    boxSizing: 'border-box',
  },
  content: {
    maxWidth: '472px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  description: {
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '28px',
    maxWidth: '475px',
    textAlign: 'center',
    color: (theme) => theme.palette.secondary.main,
  },
  imageContainer: {
    height: 'auto',
    width: '100%',
    maxWidth: '250px',
    maxHeight: '250px',
    marginBottom: '40px',
  },
  image: {
    height: '100%',
    width: 'auto',
  },
};

export default function FormAnswerForbiddenAccessState() {
  const lang = useLanguage();

  return (
    <Box sx={customStyles.root}>
      <Box sx={customStyles.content}>
        <Box sx={customStyles.imageContainer}>
          <FormAnswersForbiddenAccessStateIcon sx={customStyles.image} />
        </Box>
        <Typography
          variant='h1'
          sx={customStyles.description}
        >
          {lang.form_answer.forbidden_access}
        </Typography>
      </Box>
    </Box>
  );
}
